import React,{Component,useState } from 'react';
import { NavLink } from 'react-router-dom';



function FormComponent() {

  
        
        const script = document.createElement("script");
     
        script.src = "/assets/js/menutoggle.js";
       
        script.async = true;
     
        document.body.appendChild(script); 

        const [formData, setFormData] = useState({
    n: '',
    e: '',
    goal: '',
    company: ''
  });
  const [clicked, setClicked] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    setClicked(false);
  };

  const allFieldsFilled = Object.values(formData).every(value => value.trim() !== '');
  const handleClick = () => {
    if (allFieldsFilled) {
      setClicked(true);
    }
  };
       
      
      
  
      
    
 
        return(
            <div class="privacypageupperdiv  page-create-account royaltytaxadvisorssignup">
            <div class="main-banner companybg newonetop pri thissignup">
        
                <div class="container">
                
                <header class="main-header d-flex justify-content-between">
               <div class="site-logo">
                  
                   <a href="/" > <img src="/assets/images/home4/royalty_tax_black.png" class="desklogo signupbl royalty" /></a>
                
               </div>
               
            </header>
                
            </div> </div> 
    
            <section class="sectionBuilder hero --feature-callout -first">
    <div class="container -full">
        <div class="row -center hero-row">
            <div class="signupForm-homepage-center col-xsmall-12 col-small-8 col-small-offset-2 col-medium-10 col-medium-offset-1 col-large-8 col-large-offset-2 col-xlarge-6 col-xlarge-offset-3">
                <h4 class="heading -spacing-2 -h3 signuptitle">Start with a Consultation</h4>
                
                <form class="signupForm hidden-logged-in signupForm-homepage-center">
                    <div class="signupForm-container">
                        <div class="signupForm-row">
                        <div class="form-group">
                                
                                <input type="text" name="n" required  value={formData.n}  onChange={handleChange}  class="form-control royalty-form-input" placeholder="Name" id="work-email" />
                            </div>
                            <div class="form-group">
                                
                                <input type="email"  value={formData.e} onChange={handleChange} name="e" required  class="form-control royalty-form-input" placeholder="name@email.com" id="work-email" />
                            </div>
                            <div class="form-group">
                                
                                <input type="text" name="company" required  value={formData.company}  onChange={handleChange}  class="form-control royalty-form-input" placeholder="Company" id="work-email" />
                            </div>
                            <div class="form-group">
                                
                                <input type="text" name="goal" required   value={formData.goal}  onChange={handleChange}  class="form-control royalty-form-input" placeholder="Goals" id="work-email" />
                            </div>

                            <div class="submit-btn">
                                <span id="go-to-nextStep"   disabled={!allFieldsFilled}
        style={{
          backgroundImage: clicked  ? 'linear-gradient(180deg, #fff, #fff)' : '',
          borderColor: clicked  ? '#fff':'',
          border: clicked  ? '1px solid #000':'',
          color: clicked  ? '#000' : '',
          lineHeight: clicked  ? '47px' : '',
          cursor: clicked  ? 'pointer' : ''
        }} class="btn btn-lg btn-flat btn-block btn-primary" onClick={handleClick}> {clicked  ? 'Thank You' : 'Next'} </span>
                            </div>
                        </div>
                    </div>
                </form>
                <p class="subheading -spacing-1 hero-legal-copy hj">
                    By signing up, I agree to the Royalty Tax <a href="/" class="css-1kfjk3x-Link">Privacy Policy</a> and <a href="/" class="css-1kfjk3x-Link">Terms</a>.
                </p>
            </div>
        </div>
        <div class="row -ta-center page-aside-row">
            <div>
                <div class="feature-callout">
                   
                    <h2
                        class="feature-callout__header"
                        data-gtm-vis-recent-on-screen-6076898_224="1739"
                        data-gtm-vis-first-on-screen-6076898_224="1739"
                        data-gtm-vis-total-visible-time-6076898_224="100"
                        data-gtm-vis-has-fired-6076898_224="1"
                    >
                       Royalty Tax Offers
                    </h2>
                    <div class="feature-callout__list list">
                        <div class="list__icon"><img src="https://luna1.co/dec30d.png" alt="check icon" width="22" /></div>
                        <p class="list__item">Tax Consulting</p>
                        <div class="list__icon"><img src="https://luna1.co/dec30d.png" alt="check icon" width="22" /></div>
                        <p class="list__item">Tax Planning</p>
                        <div class="list__icon"><img src="https://luna1.co/dec30d.png" alt="check icon" width="22" /></div>
                        <p class="list__item">Bookkeeping</p>
                        <div class="list__icon"><img src="https://luna1.co/dec30d.png" alt="check icon" width="22" /></div>
                        <p class="list__item">S Corp & LLC Setup</p>
                        <div class="list__icon"><img width="18" /></div>
                       
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

       
       </div>
        );
    
}

export default FormComponent;